import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector      : 'app-community',
	templateUrl   : './community.component.html',
	encapsulation : ViewEncapsulation.None,
})

export class CommunityComponent implements OnInit {
	@Input() communityData   : any;
	@Input() communityParent : any;
	@Input() contentPages    : any;
	@Input() sponsorInfo     : any;
	@Input() selectedTab     : any;
	public isMobile : boolean;

	constructor(
		private router : Router,
	) {
		if ( devicePixelRatio > 1.5 && document.body.clientWidth < 767 )
            this.isMobile = true;
        else
            this.isMobile = false;
        this.router.navigate(["/404"]);
	}

	ngOnInit() {}

	ngAfterViewInit() {
		document.querySelector( 'body' ).classList.add( 'body-community-page' );
	}

	accordion( event : any, classname : string ) {
		const target   = event.target;
		const hasClass = target.parentElement.classList.contains( classname );
		if( hasClass )
			target.parentElement.classList.remove( classname );
		else {
			var elems = document.querySelectorAll( '.' + classname );
			[].forEach.call( elems, function( el ) {
				el.classList.remove( classname );
			});
			target.parentElement.classList.add( classname );
		}
		if ( this.isMobile ) {
			setTimeout( () => {
				const scrollElement = document.querySelector( '.' + classname );
				const yCoordinate = scrollElement.getBoundingClientRect().top + window.pageYOffset;
				let yOffset;

				yOffset = -60;
				window.scrollTo({
					top: yCoordinate + yOffset,
					behavior: 'smooth'
				});
			}, 1 );
		}
	}

	addMenuId( object_id ) {
		sessionStorage.setItem( 'currentPageID', JSON.stringify( object_id ) );
	}
}